module.exports = __webpack_public_path__ + "img/admit2.0d5fd858.png";